var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_superuser)?_c('div',{staticClass:"navbar-expand-md"},[_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbar-menu"}},[_c('div',{staticClass:"navbar navbar-light"},[_c('div',{staticClass:"container-fluid"},[_c('Topmenu')],1)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }